import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { convertPxToVw } from '../../utils';
let ContentEBook = class ContentEBook extends Vue {
    constructor() {
        super(...arguments);
        this.vip_config = null;
        this.list = [];
    }
    get boxStyle() {
        return `background: ${this.data.bgColor || '#F5F5F5'};
            padding: 0 ${this.data.compMargin}px;
            --contentMargin: ${(convertPxToVw(this.data.spacing) || 0) / 2}vw;
            --conentRadio2: ${convertPxToVw((this.data.spacing / 3) * 2)}vw;
            --conentRadio3: ${convertPxToVw(this.data.spacing / 3)}vw`;
    }
    get noticeStyle() {
        return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`;
    }
    get radiusStyle() {
        return {
            'border-radius': this.data.radius + 'px',
            padding: this.data.whiteCard
                ? this.data.lineRule === 'three'
                    ? '5px'
                    : '12px'
                : '0px',
            background: this.data.whiteCard ? '#fff' : this.data.bgColor || '#F5F5F5',
        };
    }
    get coverFill() {
        return `object-fit: ${this.data.filling}; ${this.radiusStyle}`;
    }
    async created() {
        await env.init();
        let ids = this.data.ebooks.map(r => r.id);
        let { data } = await this.$axios.post(`/api/audios/resource/book/booksById`, {
            ids: ids,
        });
        let map = new Map();
        data.forEach(element => {
            map.set(element.id, element);
        });
        this.list = [];
        this.data.ebooks.map(r => {
            if (map.get(r.id)) {
                this.list.push(map.get(r.id));
            }
        });
        if (this.config && this.config.vip_config) {
            this.vip_config = this.config.vip_config;
        }
    }
    async goEbook(value) {
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: value.title,
            JumpType: '绘本详情',
            JumpContentName: value.title,
            JumpContentID: value.id,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        if (env.type === 'ivydad' || env.type === 'wx') {
            env.commonJump(`ivydadreadtool://detail/book?id=${value.id}`);
        }
        else {
            this.$Toast('请在微信或者app端打开~');
        }
    }
    formatPlayCount(data) {
        let count = data.show_count + data.virtual_show_count;
        if (+count >= 100000000)
            return `${(+count / 100000000).toFixed(1)}亿`;
        if (+count >= 10000)
            return `${(+count / 10000).toFixed(1)}万`;
        return count || 0;
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], ContentEBook.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], ContentEBook.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], ContentEBook.prototype, "config", void 0);
ContentEBook = tslib_1.__decorate([
    Component({
        inheritAttrs: false,
    })
], ContentEBook);
export default ContentEBook;
